
import { Component, Vue, Prop } from 'vue-property-decorator';
import axios from 'axios';
import { CategoryVO } from '@/views/biz/menu/vo/category.vo';
import Products from '@/components/Products.vue'
import CommonUtils from '@/common-utils';

@Component<CategoryProducts>({ 
  components: {Products}
})
export default class CategoryProducts extends Vue {
  // data
  category: CategoryVO = {} as CategoryVO;
  @Prop() cateCd!: string;

  // initialized events
  created(): void {
    // 카테고리 정보(단건)
    axios.get(`/category/${this.cateCd}`)
    .then((r) => {
      this.category = r.data as CategoryVO;
      CommonUtils.setDocumentTitle([this.category.repFullCateNm]);
      CommonUtils.setMetaDiscription(this.category.description);
      // 헤더 link href
      CommonUtils.setHeadLink(this.$route.fullPath.slice(1));
    });
  }  
}
